import { render, staticRenderFns } from "./aiTitle.vue?vue&type=template&id=e5a370dc&scoped=true"
import script from "./aiTitle.vue?vue&type=script&lang=js"
export * from "./aiTitle.vue?vue&type=script&lang=js"
import style0 from "./aiTitle.vue?vue&type=style&index=0&id=e5a370dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a370dc",
  null
  
)

export default component.exports